/**
 *  节流方法
 */

let reqList = []

let maxTime = 500

function stopRepeatRequest (url, cancelFun) {
  if (reqList.length !== 0 && reqList.find(i => i.url === url)) {
    // url存在并且时间未到，取消调用
    let arr = reqList.filter(item => item.url === url && new Date().getTime() - item.time < maxTime)
    if (arr && arr.length !== 0) {
      console.error('axios cancel url:', url)
      cancelFun()
    } else {
      // 存在，时间已过并且没有清掉
      reqList = reqList.map(i => {
        if (i.url === url) {
          i.time = new Date().getTime()
        }
        return i
      })
    }
  } else {
    // 不存在直接push
    reqList.push({
      url,
      time: new Date().getTime()
    })
  }
}

function allowRequest () {
  if (reqList.length) {
    reqList = reqList.filter(item => new Date().getTime() - item.time < maxTime)
  }
}

export default {
  stopRepeatRequest,
  allowRequest
}



// WEBPACK FOOTER //
// ./src/plugin/axios/throttle.js